import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

// Uncomment to package css transpiled from index.scss into index.css
//import './index.css';
import './shims/polyfills'

import * as Search from './Components/search/SearchApp';
import SearchApp from './Components/search/Features/Combined/CombinedSearchResults'
import SDSSearch from './Components/sdssearch/SDSSearchApp';
import KitInsertSearch from './Components/kitinsertsearch/KitInsertSearchApp';
import DocumentSearch from './Components/documentsearch/DocumentSearchApp';

if (typeof window === 'undefined')
    var window = {};

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer

global.Search = SearchApp;
global.SolutionSearch = Search.SolutionSearch;
global.ArticleSearch = Search.ArticleSearch;
global.NeoCenterListingPage = Search.NeoCenterListingPage;
global.SDSSearch = SDSSearch;
global.KitInsertSearch = KitInsertSearch;
global.DocumentSearch = DocumentSearch;